declare namespace $ {

	type $mol_view__sub_shm_ba_date_1 = $mol_type_enforce<
		ReturnType< $shm_ba_date['date_from_picker_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_ba_date_2 = $mol_type_enforce<
		ReturnType< $shm_ba_date['date_to_picker_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_date_view__value_shm_ba_date_3 = $mol_type_enforce<
		ReturnType< $shm_ba_date['date_from'] >
		,
		ReturnType< $shm_date_view['value'] >
	>
	type $shm_date_view__value_min_shm_ba_date_4 = $mol_type_enforce<
		ReturnType< $shm_ba_date['date_min'] >
		,
		ReturnType< $shm_date_view['value_min'] >
	>
	type $shm_date_view__value_max_shm_ba_date_5 = $mol_type_enforce<
		ReturnType< $shm_ba_date['date_max'] >
		,
		ReturnType< $shm_date_view['value_max'] >
	>
	type $shm_date_view__bubble_content_shm_ba_date_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_date_view['bubble_content'] >
	>
	type $mol_view__sub_shm_ba_date_7 = $mol_type_enforce<
		ReturnType< $shm_ba_date['date_from_calendar_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_date_view__value_shm_ba_date_8 = $mol_type_enforce<
		ReturnType< $shm_ba_date['date_to'] >
		,
		ReturnType< $shm_date_view['value'] >
	>
	type $shm_date_view__value_min_shm_ba_date_9 = $mol_type_enforce<
		ReturnType< $shm_ba_date['date_min'] >
		,
		ReturnType< $shm_date_view['value_min'] >
	>
	type $shm_date_view__value_max_shm_ba_date_10 = $mol_type_enforce<
		ReturnType< $shm_ba_date['date_max'] >
		,
		ReturnType< $shm_date_view['value_max'] >
	>
	type $shm_date_view__bubble_content_shm_ba_date_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_date_view['bubble_content'] >
	>
	type $mol_view__sub_shm_ba_date_12 = $mol_type_enforce<
		ReturnType< $shm_ba_date['date_to_calendar_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_ba_date_13 = $mol_type_enforce<
		ReturnType< $shm_ba_date['preset_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_button_minor__title_shm_ba_date_14 = $mol_type_enforce<
		ReturnType< $shm_ba_date['option_label'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_ba_date_15 = $mol_type_enforce<
		ReturnType< $shm_ba_date['preset_pick'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	export class $shm_ba_date extends $shm_period {
		date_from( next?: string ): string
		date_min( ): string
		date_max( ): string
		date_from_picker_content( ): readonly(any)[]
		Date_from_bubble( ): $mol_view
		date_from_calendar_content( ): readonly(any)[]
		date_to( next?: string ): string
		date_to_picker_content( ): readonly(any)[]
		Date_to_bubble( ): $mol_view
		date_to_calendar_content( ): readonly(any)[]
		preset_rows( ): readonly(any)[]
		option_label( id: any): string
		preset_pick( id: any, next?: any ): any
		period_all( ): ({ 
			'from': string,
			'to': string,
		}) 
		Date_from( ): $shm_date_view
		Date_from_calendar_column( ): $mol_view
		Date_to( ): $shm_date_view
		Date_to_calendar_column( ): $mol_view
		Presets_list( ): $mol_list
		Preset( id: any): $mol_button_minor
	}
	
}

//# sourceMappingURL=date.view.tree.d.ts.map